













import Vue from "vue";

export default Vue.extend({
  props: {
    message: {
      type: String,
      required: false
    },
    code: {
      type: String,
      required: false
    }
  }
});
